var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 119.2 95.9",
    style: {
      enableBackground: "new 0 0 119.2 95.9"
    },
    xmlSpace: "preserve",
    fill: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M105.2,60.1l11.7-37.5c0.4-1.3,0.2-2.7-0.6-3.8c-0.8-1.1-2.1-1.7-3.4-1.7H28.9L24.1,4.6c-0.6-1.6-2.2-2.7-4-2.7H6.3 C4,1.8,2.1,3.7,2.1,6.1c0,2.3,1.9,4.2,4.2,4.2h10.9l4.7,12.2c0,0,0,0.1,0,0.1l0.1,0.4l14.2,37c0,0.1,0.1,0.3,0.1,0.4l3.8,10 c-4,2.1-6.8,6.3-6.8,11.1C33.4,88.5,39,94,45.9,94c6.9,0,12.4-5.6,12.4-12.5c0-1.4-0.2-2.7-0.6-4h25.5c-0.4,1.2-0.6,2.6-0.6,4 C82.6,88.5,88.2,94,95,94c6.9,0,12.4-5.6,12.4-12.5c0-6.9-5.6-12.4-12.4-12.4H48.8L46.5,63h54.7C103,63,104.7,61.8,105.2,60.1z  M99,81.6c0,2.2-1.8,4-4,4c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4C97.2,77.6,99,79.4,99,81.6z M49.8,81.6c0,2.2-1.8,4-4,4 c-2.2,0-4-1.8-4-4c0-2.2,1.8-4,4-4C48.1,77.6,49.8,79.4,49.8,81.6z M43.2,54.5l-11.1-29h74.9l-9,29H43.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.a768c247.svg";
export { ForwardRef as ReactComponent };